const constSnipcart = Object.freeze({
  API_BASE_URL: 'https://app.snipcart.com/api',
  BTN_LABEL_PREORDER: 'Preorder',
  BTN_LABEL_ADD: 'Shop Now',
  BTN_LABEL_UNAVAILABLE: 'Coming Soon',
})

export default constSnipcart
